export default __webpack_public_path__ + "img/4457900761d59942fd80e35ef3911ee6.svg";